// eslint-disable-next-line max-len
export const VK_VIDEO_COMMON_VIDEO_ID_REGEXP = /^(?:https?:)?(?:\/\/)?(?:w{3}\.)?(?:vk\.ru|vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?(?:.+)?oid=(-?\d+)(?:.+)?id=(\d+)|video(?:\?(?:.+)?z=video)?(?:(-?\d+)_(\d+))?)(?:.+)?$/gi;

const parseMaybeVkVideo = (value) => {
    if (typeof value !== 'string') {
        return false;
    }

    const [match] = value.matchAll(VK_VIDEO_COMMON_VIDEO_ID_REGEXP);

    if (!match) {
        return;
    }

    const oid = match[1] || match[3];
    const id = match[2] || match[4];

    if (!oid || !id) {
        return;
    }

    return {
        type: 'vk_video',
        src: `https://vk.com/video_ext.php?oid=${oid}&id=${id}`,
    };
};

export default parseMaybeVkVideo;
